import React from 'react';
import { riskScoresId } from '../../../types';
import { RiskScoresTableHead } from './RiskScoresTableHead';
import { RiskScoresTableBody } from './RiskScoresTableBody';

export const RiskScoresTable = () => {
  const id = `${riskScoresId}Table`;
  return (
    <div data-testid={id} data-cy={id} className="defeds-table-container">
      <table className="defeds-table">
        <RiskScoresTableHead />
        <RiskScoresTableBody />
      </table>
    </div>
  );
};
